import Vue from "vue";
import Vuex from "vuex";
import config from "@/utils/config.js";
import question from "./modules/question.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appId: config.appId, //问卷加加
  },
  mutations: {},
  actions: {
    setAppId({ commit }, appId) {
      commit("setAppId", appId);
    },
  },
  getters: {
    getAppId: (state) => state.appId,
  },
  modules: {
    question,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js